import { HomeMapMarkerIcon } from './HomeMapMarkerIcon';

/**
 * author: Simran
 * id D543BDC6-BC40-4A36-B2F0-60313D8F4EEB
 * name home-map-marker
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-map-marker.svg
 * tags
 * - Home Automation 
 * - Navigation 
 */
export const HomeLocationIcon = HomeMapMarkerIcon;
export default HomeLocationIcon